export default "__VITE_ASSET__CrbG_sO4__"